<div class="d-flex">
	<div class="h3 mx-4 mt-2 mb-1">Dealer Finance & Billing Setup</div>
	<div class="d-flex ms-auto">
		<div class="m-2" *ngIf="userService.user?.role >= 5">
			<span class="p-float-label">
				<p-dropdown
					#dealerList
					[options]="dealerService.dealerList.value"
					optionLabel="name"
					optionValue="key"
					name="dealerList"
					[(ngModel)]="selectedDealerKey"
					(onChange)="dealerService.initDealer(selectedDealerKey)"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					filterBy="name"
				></p-dropdown>
				<label for="dealerList">Dealer</label>
			</span>
		</div>
		<app-record-control-footer
			[hideCancel]="true"
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="(undefined)"
			(onDeleteChange)="(undefined)"
			(onSaveChange)="onSave()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="!changesToSave"
		></app-record-control-footer>
	</div>
</div>
<div *ngIf="dealerService.dealer.value.key">
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card m-2 flex-column">
				<div class="m-2 h3">{{ dealerService.dealer.value.name }}</div>
				<div class="p-grid">
					<div class="p-col-12 p-md-6">
						<div class="d-flex">
							<div class="h3 mx-4 mt-2 mb-1">Dealership Setup</div>
						</div>
						<p-divider></p-divider>
						<div class="d-flex">
							<div class="my-auto">Finance Integration enabled</div>

							<p-inputSwitch
								[(ngModel)]="dealerService.dealer.value.contractFinanceEnabled"
								(onChange)="changesToSave = true"
								class="ms-auto"
							></p-inputSwitch>
						</div>

						<div *ngIf="dealerService.dealer.value.contractFinanceEnabled" class="mt-4">
							<span class="p-float-label">
								<p-dropdown
									#idValue
									[options]="financeIntegrations"
									optionLabel="label"
									optionValue="value"
									name="idValue"
									[(ngModel)]="dealerService.dealer.value.financeIntegration"
									[style]="{ width: '100%' }"
									appendTo="body"
									[autoDisplayFirst]="false"
									[virtualScroll]="true"
									virtualScrollItemSize="30"
									filter="true"
									(filterBy)="app.keys(financeIntegrations)"
									(onChange)="changesToSave = true"
								></p-dropdown>
								<label for="idValue">Integration</label>
							</span>
						</div>
					</div>
					<div class="p-col-12 p-md-6" *ngIf="dealerService.dealer.value.financeIntegration === 2">
						<div class="d-flex">
							<div class="h3 mx-4 mt-2 mb-1">QuickBooks Status</div>
						</div>
						<p-divider></p-divider>
						<div class="p-grid">
							<div class="p-col">Connected</div>
							<div class="p-col">
								<p-skeleton *ngIf="!oauthFetched"></p-skeleton>
								<div *ngIf="oauthIntegration">
									{{ app.moment(oauthIntegration.created).format("l LT") }}
								</div>
								<div *ngIf="oauthFetched && !oauthIntegration">
									<i>not connected</i>
								</div>
							</div>
						</div>
						<div class="p-grid">
							<div class="p-col">Connection Expires</div>
							<div class="p-col">
								<p-skeleton *ngIf="!oauthFetched"></p-skeleton>
								<div *ngIf="oauthIntegration">
									{{ app.moment(oauthIntegration.expirationDateTime).format("l LT") }}
								</div>
								<div *ngIf="oauthFetched && !oauthIntegration">
									<i>not connected</i>
								</div>
							</div>
						</div>
						<app-quickbooks-oauth-connect
							*ngIf="!oauthIntegration && oauthFetched"
							[(dealerKey)]="dealerService.dealer.value.key"
							function="connect"
							source="quickbooks"
						></app-quickbooks-oauth-connect>
						<app-quickbooks-oauth-connect
							*ngIf="oauthIntegration"
							[(dealerKey)]="dealerService.dealer.value.key"
							function="disconnect"
							source="quickbooks"
						></app-quickbooks-oauth-connect>
						<app-quickbooks-oauth-connect
							*ngIf="app.moment(oauthIntegration?.expirationDateTime).isBefore(app.moment())"
							[(dealerKey)]="dealerService.dealer.value.key"
							function="refresh"
							[(refreshedToken)]="oauthIntegration"
						></app-quickbooks-oauth-connect>
					</div>
					<div class="p-col-12 p-md-3"></div>
				</div>
			</div>
		</div>
	</div>
</div>

<app-contract-finance-venue-customer-list
	#ContractFinanceVenueCustomerListComponent
	*ngIf="dealerService.dealer.value.key && integrationActive"
	[(changesToSave)]="changesToSave"
></app-contract-finance-venue-customer-list>
